"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _MenuItem = require("./MenuItem.styles");

var _elements = require("../../../styles/elements");

var _SubMenu = _interopRequireDefault(require("../SubMenu/SubMenu"));

var _Dot = _interopRequireDefault(require("../../Dot/Dot"));

var _icons = require("../../../assets/icons");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Item = (0, _base["default"])("button", {
  target: "e1vrlkw30",
  label: "Item"
})(_elements.button.styles.preflight, ";", _MenuItem.styles.base, ";");

var MenuItem = function MenuItem(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      children = _ref.children,
      subMenu = _ref.subMenu,
      as = _ref.as,
      active = _ref.active,
      defaultOpen = _ref.defaultOpen,
      onClick = _ref.onClick,
      value = _ref.value,
      dotColor = _ref.dotColor,
      count = _ref.count,
      isSubMenuItem = _ref.isSubMenuItem,
      hasArrow = _ref.hasArrow,
      subMenuCls = _ref.subMenuCls,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "icon", "children", "subMenu", "as", "active", "defaultOpen", "onClick", "value", "dotColor", "count", "isSubMenuItem", "hasArrow", "subMenuCls"]);

  var _useState = (0, _react.useState)(defaultOpen),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClick = (0, _react.useCallback)(function (e) {
    if (!subMenu) {
      // Only change active item when it doesn't have subMenu
      onClick(e, value);
    }

    setOpen(function (previousState) {
      return !previousState;
    });
  }, [onClick, subMenu, value]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(Item, _objectSpread(_objectSpread({
      as: as,
      className: (0, _clsx["default"])('grui', {
        active: active
      }, className),
      hasBackground: active && !subMenu,
      isSubMenuItem: isSubMenuItem,
      onClick: handleClick
    }, otherProps), {}, {
      children: [icon, dotColor && (0, _jsxRuntime.jsx)(_Dot["default"], {
        color: dotColor,
        size: "small",
        className: "grui mr-3 opacity-100"
      }), (0, _jsxRuntime.jsx)("span", {
        className: "grui truncate",
        children: children
      }), hasArrow && (0, _jsxRuntime.jsx)(_icons.ChevronRight, {
        className: "grui opacity-50",
        css: [_MenuItem.styles.arrow, open && _MenuItem.styles.openedArrow, process.env.NODE_ENV === "production" ? "" : ";label:MenuItem;"]
      }), !!count && (0, _jsxRuntime.jsx)("span", {
        className: "grui ml-auto count",
        css: [_elements.text.styles.text3Xs, _MenuItem.styles.count, process.env.NODE_ENV === "production" ? "" : ";label:MenuItem;"],
        children: (0, _jsxRuntime.jsx)("span", {
          children: count
        })
      })]
    })), subMenu && (0, _jsxRuntime.jsx)(_SubMenu["default"], {
      open: open,
      css: _MenuItem.styles.submenu,
      className: subMenuCls,
      children: subMenu
    })]
  });
};

MenuItem.propTypes = {
  className: _propTypes.string,

  /**
   * Customize element type
   */
  as: _propTypes.elementType,
  icon: _propTypes.node,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  subMenu: _propTypes.node,
  active: _propTypes.bool,

  /**
   * Should open the submenu in the beginning
   */
  defaultOpen: _propTypes.bool,
  onClick: _propTypes.func,

  /**
   * The unique identifier in the whole menu for the menu item,
   * will pass it through onClick
   */
  value: _propTypes.string,
  dotColor: _propTypes.string,
  count: _propTypes.number,
  isSubMenuItem: _propTypes.bool,
  hasArrow: _propTypes.bool,
  subMenuCls: _propTypes.string
};
MenuItem.defaultProps = {
  className: undefined,
  as: 'button',
  icon: undefined,
  children: undefined,
  subMenu: undefined,
  active: false,
  defaultOpen: false,
  onClick: function onClick() {},
  value: undefined,
  dotColor: undefined,
  count: undefined,
  isSubMenuItem: false,
  hasArrow: false,
  subMenuCls: undefined
};
var _default = MenuItem;
exports["default"] = _default;
//# sourceMappingURL=MenuItem.js.map